<div *ngIf="docTransactionList as transactionList else cloading">
  <p-table [value]="transactionList"
           sortMode="single"
           sortField="DOCDATE"
           sortOrder="-1"
           dataKey="DOCID"
           selectionMode="single"
           [(selection)]="selectedDocument"
           rowExpandMode="single"
           [rowHover]="true"
           [resizableColumns]="true"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">

    <ng-template pTemplate="caption">
        <div class="col align-self-start">
          <p-checkbox name="showAll" [(ngModel)]="showAllTypes" [binary]="true" label="Все типы" (onChange)="reloadChildDocs($event)"
                      pTooltip="Показывать все подчиненные документы" tooltipPosition="top"></p-checkbox>
        </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th resizableColumns style="width: 3rem">...</th>
        <th resizableColumns style="width: 17%">Документ</th>
        <th resizableColumns pSortableColumn="DOCNUMBER" style="width: 10%">Номер <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
        <th resizableColumns pSortableColumn="DOCDATE" style="width: 10%">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
        <th resizableColumns pSortableColumn="LOCALCOMP" style="width: 15%">Юрлицо <p-sortIcon field="LOCALCOMP"></p-sortIcon></th>
        <th resizableColumns pSortableColumn="AUTHOR" style="width: 15%">Автор <p-sortIcon field="AUTHOR"></p-sortIcon></th>
        <th resizableColumns pSortableColumn="CLIENTSNAME" style="width: 40%">Контрагент <p-sortIcon field="CLIENTSNAME"></p-sortIcon></th>
        <th resizableColumns pSortableColumn="DOCSUM" style="width: 8rem">Сумма <p-sortIcon field="DOCSUM"></p-sortIcon></th>
        <th resizableColumns pSortableColumn="PAYDSUM" style="width: 8rem">Оплачено <p-sortIcon field="PAYDSUM"></p-sortIcon></th>
        <th resizableColumns pSortableColumn="SHIPSUM" style="width: 8rem">Отгружено <p-sortIcon field="SHIPSUM"></p-sortIcon></th>
        <th resizableColumns pSortableColumn="DOCNOTE1" style="width: 10%">Примечание <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
        <th resizableColumns pSortableColumn="DOCNOTE2" style="width: 10%">Примечание <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-tranList let-expanded="expanded">
      <tr [pSelectableRow]="tranList"
          [class.futuredocs]="tranList.fd"
          [class.grayout]="tranList.go"
          [class.underline]="tranList.ps"
          [class.strikeout]="tranList.fs"
          [class.partiallypaiddoc]="tranList.pp"
          [class.notpaiddoc]="tranList.np"
          [class.fullypaiddoc]="tranList.fp"
          [class.todaydocuments]="tranList.td"
          [class.proformadoc]="(tranList.DOCTYPEID == 12)"
          [class.inorderdoc]="(tranList.DOCTYPEID == 2)"
          [class.banktransferdoc]="(tranList.DOCTYPEID == 9)"
          [class.purchorderdoc]="(tranList.DOCTYPEID == 10)"
          [class.yellowdoc]="(tranList.DOCTYPEID == 14)"
          [class.specdoc]="(tranList.DOCTYPEID == 7)"
          [class.shiporderdoc]="(tranList.DOCTYPEID == 4)"
          [class.invoicedoc]="(tranList.DOCTYPEID == 1)">
        <td>
          <button type="button" pButton pRipple [pRowToggler]="tranList"
                  class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
        </td>
        <td style="">{{tranList.DOCNAME}}</td>
        <td style="">
          <a [routerLink]="['/edit-document', tranList.DOCTYPEID, tranList.DOCID]">
            {{tranList.DOCNUMBER}}
          </a>
        </td>
        <td style="">{{tranList.DOCDATE  | date:'dd.MM.yyyy'}}</td>
        <td style="">{{tranList.LOCALCOMP}}</td>
        <td style="">{{tranList.AUTHOR}}</td>
        <td style="max-width: 20rem">
          <a [routerLink]="['/edit-client', tranList.DOCCLIENTSID]">
            {{tranList.CLIENTSNAME}}
          </a>
        </td>
        <td style="text-align: right">{{tranList.DOCSUM | number:'1.2-2' }}</td>
        <td style="text-align: right">{{tranList.PAYDSUM | number:'1.2-2' }}</td>
        <td style="text-align: right">{{tranList.SHIPSUM | number:'1.2-2' }}</td>
        <td style="max-width: 10rem">{{tranList.DOCNOTE1}}</td>
        <td style="max-width: 10rem">{{tranList.DOCNOTE2}}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-tranList>
      <tr>
        <td colspan="12">
          <div class="p-p-2">
            <app-document-content-table [selectedDocumentId]="tranList.DOCID" [showFooterTotal]="true"></app-document-content-table>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="12">На сегодня документов нет</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #cloading>
  <p>Содержимое загружается...</p>
</ng-template>
